import React, { ReactNode, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getPostbillLocalStorage } from "../../utils/localStorage";
import { routes } from "@app/routing";

interface TokenExpiryWatcherProps {
  children: ReactNode;
  expireTime: number | null;
}

const TokenExpiryWatcher: React.FC<TokenExpiryWatcherProps> = ({
  children,
  expireTime,
}) => {
  const loginAuth = getPostbillLocalStorage("authType");
  const token = getPostbillLocalStorage("guestToken");
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const getRedirectPath = () => {
    if (loginAuth === "guest" && token)
      return `${routes.postbillGuestLogin}?token=${token}`;
    if (loginAuth === "public") return routes.billingCenterGuestLogin;
    return null;
  };

  useEffect(() => {
    if (!(loginAuth === "guest" || loginAuth === "public")) return;
    if (!expireTime) return;

    const now = Date.now();
    const fiveMinutesBefore = expireTime - 300_000; // 5 minutes before expiry time
    const delay = fiveMinutesBefore - now;
    const path = getRedirectPath();

    if (delay <= 0) {
      navigate(path ?? routes.logIn);
      return;
    }

    timeoutRef.current = setTimeout(() => {
      navigate(path ?? routes.logIn);
    }, delay);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [expireTime, loginAuth, navigate]);

  return <>{children}</>;
};

export default TokenExpiryWatcher;
